import React from 'react';
import useLanguageCode from 'hooks/useLanguageCode';
import { StringConstantsMixin } from 'react_components/mixins/shared/string_constants_mixin';
import * as styles from './styles/styles.module.scss';

const HelpButton = () => {
  const languageCode = useLanguageCode();
  const supportLink = `https://support.alltrails.com/hc/${languageCode}/articles/360019245911-How-do-I-create-a-map-`;
  return (
    <a className={styles.button} target="_blank" rel="noreferrer" href={supportLink}>
      {StringConstantsMixin.strings.MAP_CREATOR.NEED_HELP}
    </a>
  );
};

export default HelpButton;
